import { Outlet } from 'react-router-dom'
import { TopBar } from './components/layout/TopBar'
import { ErrorBoundary } from '@/components/error-boundary'
import { DevMockToggle } from '@/mocks/DevMockToggle'

export function App() {
  return (
    <div className="bg-background text-foreground min-h-screen w-full transition-colors duration-200">
      <TopBar />
      <main className="mx-auto w-full max-w-7xl px-4 py-6" role="main" aria-label="Main content">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <footer className="text-muted-foreground mt-auto py-4 text-center text-xs" role="contentinfo">
        © {new Date().getFullYear()} GoAudit - ระบบสนับสนุนการตรวจสอบบัญชี
      </footer>

      {/* Development Tools - only shown in DEV mode */}
      {import.meta.env.DEV && <DevMockToggle />}
    </div>
  )
}
